import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import { _checkMenuOptionsActive } from "../../../../utils/Webinar"

import arrow from "images/icons/icon_arrow_right_blue.svg";

import "./WebinarMenuOption.style";
import GeneralAnalytics from "../../../../analytics/GeneralAnalytics";

class WebinarMenuOption extends PolymerElement {
  static get template() {
    return html`
      <style include="webinar-menu-option-style"></style>
      <div class="container">
        <dom-repeat items="{{menuOptionList}}" as="optionItem">
          <template>
            <div class="item-container">
              <img src="[[iconArrowRightBlue]]" alt="alomedika" />
              <a href="{{optionItem.path}}" on-click="sendEventGaOptionPageView" class$="[[_checkMenuOptionsActive(optionItem.path)]]">{{optionItem.option_value}}</a>
            </div>
          </template>
        </dom-repeat>
      </div>
    `;
  }

  static get properties() {
    return {
      iconArrowRightBlue: {
        type: String,
        value: arrow,
      },
      
      menuOptionList: {
        type: Array,
        value() {
          return [
            {
              option_value: "Cari Webinar",
              path: "/webinar",
            },
            {
              option_value: "Aktivitas Webinar Anda",
              path: "/webinar/activity",
            },
            {
              option_value: "FAQ",
              path: "/webinar/faq",
            },
          ];
        },
      },
      _checkMenuOptionsActive: {
        type: Function,
        value: () => _checkMenuOptionsActive
      }
    };
  }

  sendEventGaOptionPageView(e) {
    let path = e.target.pathname;
    if (path == "/webinar/faq") {
      GeneralAnalytics.faq("webinar", "landing")
    } 
  }
}
customElements.define("webinar-menu-option", WebinarMenuOption);
